module.exports = __webpack_public_path__ + "assets/events_unrest_white.f2a811d4.svg";